import { useQuery } from '@tanstack/react-query';
import { statisticsApi } from '@/api/statistics.api';

export function useStatisticsOverview(days: 7 | 30 | 90) {
  return useQuery({
    queryKey: ['statistics', 'overview', days],
    queryFn: () => statisticsApi.getOverview(days),
    staleTime: 60_000,
  });
}
